/**
 * Full page reload — Ionic caches view stacks, so router navigation alone
 * doesn't reset the app (see ADR-0004). Wrapped so tests can mock it.
 */
export const reloadTo = (path: string) => window.location.replace(path)
